import React, { useState, useEffect } from "react";
import stylesPc from "./PresentersProfiles.module.css";
import stylesSp from "./PresentersProfiles_SP.module.css";
import PresenterCard from "./PresenterCard";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { AlertTitle } from "@material-ui/lab";
import { FilteredUserInfo } from "../../models/UserFilter";
import { useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { VerticalList } from "../../../common/homePage/model/HomePage";
import { IsDevice } from "../../../components/function/useDeviceFlag";

interface PresentersProfilesProps {
    users?: FilteredUserInfo[];
    msg?: string;
    professionalName?: string;
    recProList?: VerticalList[];
    openMsg: (event: React.MouseEvent, flg: boolean, name: string) => void;
    closeMsg: () => void;
}

function PresentersProfiles(props: PresentersProfilesProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const { users, msg, professionalName, recProList, openMsg, closeMsg } = props;

    const { userFilter, isLoading, isDeleteSuccessProfessional, isDeleteFailedProfessional } =
        useSelector((state: AppState) => ({
            userFilter: state.userFilter.UserFilters,
            isLoading: state.recommendList.isLoading,
            isDeleteSuccessProfessional: state.recommendList.isDeleteSuccessProfessional,
            isDeleteFailedProfessional: state.recommendList.isDeleteFailedProfessional,
        }));

    const [isFilter, setIsFilter] = useState<boolean>(false);

    // 重複なユーザー表示を削除
    const [usersWithoutDuplicates, setUsersWithoutDuplicates] = useState<FilteredUserInfo[]>([]);
    const SetUsersWithoutDuplicates = () => {
        if (users && users.length !== 0) {
            const usersFilter = users.filter(
                (element, index, self) => self.findIndex((e) => e.id === element.id) === index
            );
            setUsersWithoutDuplicates(usersFilter);
        }
    };

    const contents = (
        <>
            <div className={styles.presenters}>
                {(!users || (users && users.length === 0)) && (
                    <div className={styles.noFilterUser}>
                        {isFilter ? (
                            <>該当するプレゼンターが見つかりませんでした</>
                        ) : (
                            <>プレゼンターが登録されていません</>
                        )}
                    </div>
                )}

                {usersWithoutDuplicates && usersWithoutDuplicates.length !== 0 && (
                    <div className={IsDevice("iphone") ? styles.iphoneGrid : styles.grid}>
                        {usersWithoutDuplicates.map((user: FilteredUserInfo, index: number) => (
                            <PresenterCard
                                key={index}
                                filteredUserInfo={user}
                                recProList={recProList}
                                link={"videos"}
                                openMsg={openMsg}
                            />
                        ))}
                    </div>
                )}
            </div>

            <Snackbar open={msg === "add"} autoHideDuration={3000} onClose={closeMsg}>
                <MuiAlert elevation={6} variant="filled" onClose={closeMsg} severity="success">
                    <AlertTitle>おすすめPresenterに登録しました</AlertTitle>
                    <li>
                        <strong>{professionalName}</strong>
                    </li>
                </MuiAlert>
            </Snackbar>

            <Snackbar
                open={!isLoading && msg === "del" && isDeleteSuccessProfessional}
                autoHideDuration={3000}
                onClose={closeMsg}
            >
                <MuiAlert elevation={6} variant="filled" onClose={closeMsg} severity="error">
                    <AlertTitle>おすすめPresenterリストから削除しました</AlertTitle>
                    <li>
                        <strong>{professionalName}</strong>
                    </li>
                </MuiAlert>
            </Snackbar>

            <Snackbar
                open={!isLoading && msg === "del" && isDeleteFailedProfessional}
                autoHideDuration={3000}
                onClose={closeMsg}
            >
                <MuiAlert elevation={6} variant="filled" onClose={closeMsg} severity="error">
                    <AlertTitle>おすすめPresenterの削除失敗しました。</AlertTitle>
                </MuiAlert>
            </Snackbar>
        </>
    );

    useEffect(() => {
        if (userFilter.skill.length > 0 || userFilter.tag.length > 0) {
            setIsFilter(true);
        } else {
            setIsFilter(false);
        }
    }, [userFilter]);

    // usersが変更されたら、usersWithoutDuplicatesも変更するように
    useEffect(() => {
        SetUsersWithoutDuplicates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users]);

    return <>{contents}</>;
}

export default PresentersProfiles;
